"use client"

import styled from "@emotion/styled"
import Container from "ui/Container"
import AccordionComponent from "../components/Accordion"
import InformationBlocks from "../components/InformationBox"

interface ContactUsBlockProps {
  data: any
  isSmartBlockRenderer?: boolean
}

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 40px;

  ${(p) => p.theme.breakpoints.up("md")} {
    padding-top: 88px;
  }
`

export default function ContactUsBlock({
  data,
  isSmartBlockRenderer,
}: ContactUsBlockProps) {
  return (
    <StyledLayout>
      <Container paddingMobile>
        <AccordionComponent
          data={data}
          initialClosed={true}
          isSmartBlockRenderer={isSmartBlockRenderer}
        />
        <InformationBlocks data={data} />
      </Container>
    </StyledLayout>
  )
}
